import { AttributesMixin, Collection, define, Model } from "@type-r/models";
import { filterByMultiSelect, MultiSelectFilter, TextFilter } from "lqx-react/lib";
import { RelationshipModel } from "api";
import { matchString } from "api/common";
import { fetchJson, restfulIO } from "api/endpoint";
import { root } from "./common";
import { RemittanceAdvice } from "./remittance-advice";

export interface UnresolvedRemittanceAdvice extends AttributesMixin<typeof UnresolvedRemittanceAdvice> {}

@define
export class UnresolvedRemittanceAdvice extends RemittanceAdvice {
    static endpoint = restfulIO( root + 'unresolvedRemittanceAdvices' );

    filter( filter: UnresolvedRAFilters){
        return (!filter.filterAll || (this.emailMetadata && matchString( this.emailMetadata.from, filter.filterAll))
            || (this.emailMetadata && matchString( this.emailMetadata.subject, filter.filterAll))
            || this.matches.some(m => matchString( m.invoiceNumber, filter.filterAll))
        ) && (!filter.emailSubject.value || (this.emailMetadata &&  matchString(this.emailMetadata.subject, filter.emailSubject.value)))
        && (!filter.emailFrom.selected || (this.emailMetadata && filterByMultiSelect(filter.emailFrom, this.emailMetadata.from)));
    }

    async resolveAll( supplierId, customerId, id : string) : Promise<number> {

        return await fetchJson( 'POST', root + 'unresolvedRemittanceAdvices/resolve', {
            customerPlatformCompanyId : customerId,
            supplierPlatformCompanyId : supplierId,
            raId : Number(id)
        } );
    }
}

export interface UnresolvedRAFilters extends AttributesMixin<typeof UnresolvedRAFilters> {}
@define
export class UnresolvedRAFilters extends Model {
    static attributes = {
        filterAll : '',
        emailSubject: TextFilter,
        emailFrom : MultiSelectFilter
    }

        initializeOptions(remittanceAdvices: Collection<UnresolvedRemittanceAdvice>) {
        this.filterAll = '';

        const emailFroms = remittanceAdvices.filter(ra => !!ra.emailMetadata).map(ra => ra.emailMetadata.from);
        this.emailFrom.set({selected: undefined, options: Array.from(new Set(emailFroms.filter(x => x)))});
    }
}
